var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.timeWindowCreatePermission)?_c('div',{attrs:{"id":"page-user-edit"}},[_c('vx-card',[_c('time-window-create-tab')],1)],1):_c('not-permission')
}
var staticRenderFns = []

export { render, staticRenderFns }